export const divider1 = [
  {
    top: "25%",
    width: "30px",
    delay: "1s",
  },
  {
    top: "10%",
    width: "20px",
    delay: "3.5s",
    duration: "12s",
  },
  {
    top: "70%",
    width: "20px",
    delay: "8s",
  },
  {
    top: "40%",
    width: "10px",
    delay: "0s",
    duration: "18s",
  },
];

export const divider2 = [
  {
    top: "25%",
    width: "40px",
    delay: "3s",
    duration: "28s",
  },
  {
    top: "10%",
    width: "20px",
    delay: "8s",
    duration: "16s",
  },
  {
    top: "70%",
    width: "20px",
    delay: "4s",
  },
  {
    top: "40%",
    width: "10px",
    delay: "1s",
    duration: "12s",
  },
];

export const divider3 = [
  {
    top: "25%",
    width: "40px",
    delay: "1s",
    duration: "18s",
  },
  {
    top: "10%",
    width: "20px",
    delay: "3s",
    duration: "12s",
  },
  {
    top: "70%",
    width: "15px",
    delay: "9s",
  },
  {
    top: "40%",
    width: "30px",
    delay: "0s",
    duration: "14s",
  },
];
